// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/chunks/" + chunkId + "." + "f396c7833a57e1e3" + ".js";
};